import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faFastForward,
  faPlay,
  faCheck,
  faAward,
  faHourglassHalf,
} from '@fortawesome/free-solid-svg-icons';

import bullsEye from '../../../../assets/icons/bullseye-arrow-white.svg';
import useAnalyticsEventTracker from '../../../../hooks/use-analytics';

const LessonLink = ({ location, lessonNumber, sceneId, lessonData, objectiveName, level, sceneName }) => {
  const {t: translate } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const link = `/conversation/${location}/${sceneId}/${lessonNumber}`;
  let lessonClass = 'lesson-link';
  let bgIcon = faHourglassHalf;
  const descriptions = [
    translate('learn-the-parts'),
    translate('re-order'),
    translate('have-a-conversation')
  ];
  const gaEventTracker = useAnalyticsEventTracker('Scene Selection');


  if (lessonData.completed === true) {
    if (lessonData.bestAccuracy >= 65) {
      lessonClass = 'lesson-link lesson-link--completed';
      bgIcon = faAward;
    } else {
      lessonClass = 'lesson-link lesson-link--started';
      bgIcon = faCheck;
    }
  }

  const navigateToLesson = () => {
    if (lessonData.totalAttempts === 0) {
      gaEventTracker('Lesson Started', `${location} ${objectiveName} ${level} ${sceneName} Lesson ${lessonNumber}`)
    }

    if (sceneId) {
      dispatch({
        type: 'startLesson',
        payload: { sceneID: sceneId, lesson: lessonNumber },
      });
    }

    history.push(link);
  };

  return (
    <div className={lessonClass}>
      <div className="lesson-link__bg">
        <FontAwesomeIcon icon={bgIcon} size="1x" className="bg-icon" />
      </div>
      <div className='lesson-link__header'>
        <div className='lesson-link__info'>
          <span className="lesson-link__title">{translate('lesson')} {lessonNumber}</span>
          <p className='lesson-link__description'>{descriptions[lessonNumber - 1]}</p>
        </div>
        <div className="lesson-link__stats">
          <p className="stat">
            <img
              src={bullsEye}
              alt="Lesson Accuracy"
              title="Lesson Accuracy"
              className="stat__icon"
            />
            <span>{lessonData.bestAccuracy}%</span>
          </p>
          <p className="stat">
            <FontAwesomeIcon icon={faPlay} size="1x" className="stat__icon" />
            <span>{lessonData.totalAttempts}</span>
          </p>
          <p className="stat">
            <FontAwesomeIcon
              icon={faFastForward}
              size="1x"
              className="stat__icon"
            />
            <span>{lessonData.lastSkips}</span>
          </p>
        </div>
      </div>
      <div className="lesson-link__footer">
        <div className="lesson-link__button" onClick={navigateToLesson}>
          <span>{lessonData.totalAttempts > 0 ? translate('retry') : translate('start')}</span>
          <FontAwesomeIcon icon={faChevronRight} size="1x" />
        </div>
      </div>
    </div>
  );
};

export default LessonLink;
